function GetTopicDetails() {
}

module.exports = GetTopicDetails;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/get-topic-details/get-topic-details.js
// module id = 313
// module chunks = 0